module.exports = __webpack_public_path__ + "static/media/mcm2.4fecea1d.PNG";